import { render, staticRenderFns } from "./StrokedContainer.vue?vue&type=template&id=7176daae&"
var script = {}
import style0 from "./StrokedContainer.vue?vue&type=style&index=0&id=7176daae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports